var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockSync(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.758,
    height: 23.723,
    viewBox: "0 0 20.758 23.723",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "lock_sync") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#00a0e9;}.b,.c{fill:#fff;}.b{opacity:0;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18.534,10.379H17.422V7.043a7.043,7.043,0,0,0-14.086,0v3.336H2.224A2.225,2.225,0,0,0,0,12.6v8.9a2.225,2.225,0,0,0,2.224,2.224h16.31A2.225,2.225,0,0,0,20.758,21.5V12.6A2.225,2.225,0,0,0,18.534,10.379Zm-4.819,0H7.043V7.043a3.336,3.336,0,1,1,6.672,0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-984.161 -281.639)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(988.088 293.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 12,
    height: 11,
    transform: "translate(0.072 0.138)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M10.994,6.487a.292.292,0,0,0,.033-.09l.353-1.885a.479.479,0,1,0-.942-.17l-.174.942a4.344,4.344,0,0,0-7.812.4.472.472,0,0,0,.876.353A3.336,3.336,0,0,1,6.476,3.957a3.378,3.378,0,0,1,2.94,1.687l-.777-.127a.477.477,0,1,0-.151.942l2,.335h.075a.438.438,0,0,0,.16-.028.156.156,0,0,0,.047-.028.368.368,0,0,0,.094-.052l.038-.047a.5.5,0,0,0,.066-.075.273.273,0,0,0,.024-.075ZM10.155,8.23a.471.471,0,0,0-.617.264A3.336,3.336,0,0,1,6.41,10.553,3.378,3.378,0,0,1,3.47,8.867l.777.127h.075A.473.473,0,1,0,4.4,8.051l-2-.325a.429.429,0,0,0-.155,0H2.2a.542.542,0,0,0-.151.066.471.471,0,0,0-.085.085l-.042.047a.4.4,0,0,0-.033.09.207.207,0,0,0-.033.08L1.505,9.978a.471.471,0,0,0,.377.575h.085a.471.471,0,0,0,.471-.386l.174-.942a4.344,4.344,0,0,0,7.812-.391.471.471,0,0,0-.269-.6Z",
    transform: "translate(-0.242 -2.085)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockSync);
export default __webpack_public_path__ + "static/media/lock_sync.356ac39944b22b41950a2ad59845587e.svg";
export { ForwardRef as ReactComponent };